import { gql } from "@apollo/client";

export const GET_EPC_SUMMARY = gql`
    query EpcSummaries($bfes: [String!]!) {
        getEpcSummaries(bfes: $bfes) {
            bfe
            identifier
            classification
            street
            postalCodeAndCity
            allProposalClassification
            profitableProposalClassification

            proposals {
                title
                category
                renovationTime
                profitability
                investmentLifetime
                investment
                description

                emissionSaving
                energySaving
                costSaving
            }
        }
    }
`;
